import { EmbeddedMessage, IN_APP, PUSH } from 'constants/messageMediums';
import { fetchIntegrations, fetchMobileApps } from 'modules/mobileApps/actions';
import {
  getIsFetchingIntegrations,
  getIsFetchingMobileApps,
  selectMobileApps,
  selectMobileAppsWithIntegrations,
} from 'modules/mobileApps/selectors';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCreateCampaignContext } from '../campaignFolders/contexts/CreateCampaignContext';

export const useSelectiveTargeting = () => {
  const { messageMedium } = useCreateCampaignContext();

  const dispatch = useDispatch();

  useEffect(() => {
    if (messageMedium === PUSH || messageMedium === IN_APP || messageMedium === EmbeddedMessage) {
      dispatch(fetchIntegrations());
      dispatch(fetchMobileApps());
    }
  }, []);

  // check if still fetching
  const isFetchingMobileApps = useSelector(getIsFetchingMobileApps);
  const isFetchingIntegrations = useSelector(getIsFetchingIntegrations);

  const messageableAppsForPush = useSelector(selectMobileAppsWithIntegrations);
  const messageableAppsForInApp = useSelector(selectMobileApps);

  const [isSelectiveTargetingEnabled, setIsSelectiveTargetingEnabled] = useState(false);

  const areMobileAppsStillBeingFetched = isFetchingMobileApps || isFetchingIntegrations;

  return {
    messageableAppsForPush,
    messageableAppsForInApp,
    areMobileAppsStillBeingFetched,
    isSelectiveTargetingEnabled,
    setIsSelectiveTargetingEnabled,
  };
};
